import { useEffect, useState } from "react";
import Button from "./button";

const COOKIES_ACCEPTED_KEY = "cookiesAccepted";
const COOKIES_ACCEPTANCE_ANSWERED_KEY = "cookiesAcceptanceAnswered";

const CookieConsent = () => {
  // Start as "already answered" so nothing renders during the server render or on the
  // very first client paint — localStorage isn't readable in either case, and a consent banner
  // baked into the static HTML would be shown to visitors who already answered (and to
  // crawlers). The effect below reads the real answer as soon as we're in a browser.
  const [hasAnsweredCookiesAcceptance, setHasAnsweredCookiesAcceptance] = useState(true);

  useEffect(() => {
    try {
      setHasAnsweredCookiesAcceptance(
        localStorage.getItem(COOKIES_ACCEPTANCE_ANSWERED_KEY) === "true"
      );
    } catch {
      // localStorage unavailable (private mode, blocked cookies) — stay silent.
    }
  }, []);

  const answer = (accepted) => {
    setHasAnsweredCookiesAcceptance(true);
    try {
      localStorage.setItem(COOKIES_ACCEPTED_KEY, accepted);
      localStorage.setItem(COOKIES_ACCEPTANCE_ANSWERED_KEY, true);
    } catch {
      // localStorage unavailable — the choice just isn't remembered.
    }
  };

  return (
    !hasAnsweredCookiesAcceptance && (
      <div className="fixed bottom-4 right-4 bg-primary z-50 flex justify-center max-w-xs sm:max-w-xl p-4 flex flex-col gap-2">
        <div className="text-inverse text-sm w-full">
          Vi använder cookies för att förbättra din upplevelse samt i marknadsföringssyfte.
        </div>
        <div className="flex gap-2">
          <Button variant="black" onClick={() => answer(true)}>
            Godkänn alla
          </Button>
          <Button variant="black" onClick={() => answer(false)}>
            Neka alla
          </Button>
        </div>
      </div>
    )
  );
};

export default CookieConsent;
